import { render } from "./HideCloseButton.vue?vue&type=template&id=6f7e13de"
import script from "./HideCloseButton.vue?vue&type=script&lang=js"
export * from "./HideCloseButton.vue?vue&type=script&lang=js"
script.render = render

export default script